import { render } from "./GeneralEdit.vue?vue&type=template&id=186e6590&scoped=true"
import script from "./GeneralEdit.vue?vue&type=script&class=notranslate&lang=js"
export * from "./GeneralEdit.vue?vue&type=script&class=notranslate&lang=js"

import "./GeneralEdit.vue?vue&type=style&index=0&id=186e6590&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186e6590"]])

export default __exports__